export const GET_INSTANCE_INFO = 'GET_INSTANCE_INFO';
export const INSTANCE_INFO_ERROR = 'INSTANCE_INFO_ERROR';
